import angular from 'angular';

import AggregatedEventDetailsModalController from './AggregatedEventDetailsModalController';
import CalculateValuesService from './CalculateValuesService';
import GraphPanelService from './GraphPanelService';
import GraphRequestQueue from './GraphRequestQueue';
import GraphPanelComponent from './GraphPanelComponent';
import GraphPanelLatestReading from './GraphPanelLatestReading';
import TotalFlowMeterService from './TotalFlowModal/TotalFlowMeterService';
import TotalFlowSettingsModalComponent from './TotalFlowModal/TotalFlowSettingsModalComponent';

export default angular
  .module('petroCloud.dashboard.graphPanel', [])
  .service('CalculateValuesService', CalculateValuesService)
  .service('GraphRequestQueue', GraphRequestQueue)
  .service('GraphPanelService', GraphPanelService)
  .service('TotalFlowMeterService', TotalFlowMeterService)
  .controller('AggregatedEventDetailsModalController', AggregatedEventDetailsModalController)
  .component(GraphPanelComponent.name, GraphPanelComponent)
  .component(TotalFlowSettingsModalComponent.name, TotalFlowSettingsModalComponent)
  .filter('graphPanelLatestReading', GraphPanelLatestReading)
  .name;
